<template>
  <div pagination>
    <a @click="first" class="first" :class="{disabled: pageNow < 2}"></a>
    <a @click="prev" class="prev" :class="{disabled: pageNow < 2}"></a>
    <a v-for="page in pageList()" :key="page" :class="{on: page === pageNow }" @click="$emit('go', page)">{{ page }}</a>
    <a @click="next" class="next" :class="{disabled: totalPages === pageNow}"></a>
    <a @click="end" class="end" :class="{disabled: totalPages === pageNow}"></a>
  </div>
</template>

<style lang="less">
 @import "../../less/proj";

  [pagination] { .tc;
    a { .ib; .vam; .wh(40); .-a(@c-border); .fs(15); .lh(40); .bold;
      &.on { color:#fff; background:#464d5d; border-color:#464d5d; }
      &.prev, &.next { .bg("@{common}/paging-l.png"); .no-repeat; .bg-c; }
      &.end, &.first { .bg("@{common}/paging-ll.png"); .no-repeat; .bg-c; }
      &.next, &.end { transform:rotate(180deg); }
      &.prev { margin-right:10px; }
      &.next { margin-left:10px; }
      &.disabled { opacity: 0.5; }
    }
  }
</style>

<script>
export default {
  props: {
    result: { type: Object, default: null },
  },
  data() {
    return {
      totalPages: 0,
      pageNow: 0,
      pageStart: 0,
      pageEnd: 0,
    };
  },
  methods: {
    first() {
      if (this.pageNow === 1) return;
      this.$emit('go', 1);
    },
    prev() {
      if (this.pageNow === 1) return;
      this.$emit('go', this.pageNow - 1);
    },
    next() {
      if (this.pageNow === this.totalPages) return;
      this.$emit('go', this.pageNow + 1);
    },
    end() {
      if (this.pageNow === this.totalPages) return;
      this.$emit('go', this.totalPages);
    },
    pageList() {
      const result = [];
      if (!this.$props) {
        result.push(1);
        return result;
      }
      if (this.$props.result) {
        const data = this.$props.result;
        const len = 5;
        const c = data.pageNo - 1;
        const t = data.pageCount;
        const s = (Math.floor(c / len) * len) + 1;
        const e = s + (t - s > len - 1 ? len - 1 : t - s);
        this.pageNow = data.pageNo;
        this.totalPages = t;
        this.pageStart = s;
        this.pageEnd = e;
        for (let i = s; i <= e; i += 1) result.push(i);
      } else {
        this.pageNow = 0;
        this.totalPages = 0;
        this.pageStart = 0;
        this.pageEnd = 0;
        result.push(1);
      }
      return result;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/Pagination.vue